import { render } from "./BaseScore.vue?vue&type=template&id=5ea9cff0&scoped=true"
import script from "./BaseScore.vue?vue&type=script&lang=js"
export * from "./BaseScore.vue?vue&type=script&lang=js"

import "./BaseScore.vue?vue&type=style&index=0&id=5ea9cff0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea9cff0"]])

export default __exports__